import { render, staticRenderFns } from "./centCommission.vue?vue&type=template&id=13539df3&scoped=true&"
import script from "./centCommission.vue?vue&type=script&lang=js&"
export * from "./centCommission.vue?vue&type=script&lang=js&"
import style0 from "./centCommission.vue?vue&type=style&index=0&id=13539df3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13539df3",
  null
  
)

export default component.exports